import * as React from 'react';
import { currency } from '~/lib/formatters';


// TODO: This should be moved to sender app
const TransactionBalanceBlock = (props) => {
  const { loading, onShow, balance } = props;

  const handleShow = (e) => {
    e.preventDefault();
    onShow();
  };

  return (
    <div className='blocks__cont'>

      <div className="blocks__box">
        <span className="blocks__lbl">Current Balance</span>
        <span className="blocks__value blocks__value--balance">
          <span className="blocks__value__sign">$</span>
          {balance ? currency(balance) : 0}
        </span>
        <p className="blocks__note--sm">Funds are held by Evolve Bank & Trust (Evolve), Member FDIC. These funds are held in an account under Evolve's name, for your benefit.</p>
      </div>

      <div className="blocks__box blocks--vertical dn">
        <div className="blocks--vertical__box">
          <span className="blocks__lbl">Charges Last 30 Days</span>

          <span className="blocks__value blocks__value--charge">
            <span className="blocks__value__sign">$</span>
            8,873.85
          </span>
        </div>
        <div className="blocks--vertical__box">
          <span className="blocks__lbl">Charges Outstandng</span>
          <span className="blocks__value blocks__value--charge">
            <span className="blocks__value__sign">$</span>
            4,240.55
          </span>
        </div>
      </div>

      <div className="blocks__box dn">
        <a onClick={handleShow} href="javascript:void(null)" className="btn btn--secn btn--lg">Add Funds</a>
        <p className="blocks__note--md">ACH and Wire Transfers accepted. Processes in 1-2 business days. <a href="javascript:void(null)">Learn more</a>.</p>
      </div>
    </div>
  );
};

export default TransactionBalanceBlock;
